import { CommandPaletteResult } from '@components/command-palette/result';
import { ComboboxOption } from '@headlessui/react';
import Loader from '_common/components/loader/Loader';
import clsx from 'clsx';
import { t } from 'i18next';
import { Fragment } from 'react/jsx-runtime';
import { Order } from 'types/Order';
import { ReqType } from 'utils/REQ';

type Props = {
  req: ReqType;
  results: Order[];
};

/**
 * @package
 */
export const CommandPaletteResultsOrders = ({ req, results }: Props) => {
  if (results.length === 0 && req === 'SUCCESS') {
    return null;
  }

  return (
    <li key="pages">
      <h2 className={clsx('text-microText', 'px-xs', 'mb-xxs')}>
        {t('common:Orders')}
      </h2>
      {req === 'PENDING' ? (
        <Loader />
      ) : (
        <ul className={clsx('flex', 'flex-col', 'justify-start')}>
          {results.map(item => {
            const to = `/orders/${item.secret}`;
            return (
              <ComboboxOption
                as={Fragment}
                key={item.orderNumberString}
                value={to}
              >
                {({ focus }) => (
                  <CommandPaletteResult
                    icon="orders"
                    text={item.orderNumberString}
                    to={to}
                    focused={focus}
                  />
                )}
              </ComboboxOption>
            );
          })}
        </ul>
      )}
    </li>
  );
};
